<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="6" :md="24" v-if="this.getUserInfo.deptName === '办公室'">
          <el-form-item label="部门:" prop="deptList">
            <el-select filterable v-model="form.deptId" placeholder="请选择部门" clearable>
              <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :md="24" v-if="this.getUserInfo.deptName === '办公室'">
          <el-form-item label="姓名:" prop="userId">
            <el-select filterable v-model="form.userId" placeholder="请选择姓名" clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="7" :md="24">
          <el-form-item label="时间:" prop="date">
            <el-date-picker :clearable="false" v-model="form.date" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :md="24" class="action" style="margin-bottom:20px">
          <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
          <download-excel
            style="margin-left:20px"
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            type="xls"
            worksheet="My Worksheet"
            name="日常考勤记录"
          >
            <el-button size="small" >导出</el-button>
          </download-excel>
        </el-col>
      </el-row>
    </el-form>
    <div class="record">
      <div class="record-box" v-for="item in list" :key="item.name">
        <div class="title">{{ item.title }}</div>
        <div class="count">{{ item.count }}人</div>
      </div>
    </div>

    <PTable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template #action="record">
        <a class="success" href="javascript:;" @click='handleLook(record.row.datas)'>查看</a>
      </template>
    </PTable>
    <ItemMoudle :visible.sync='visible' :record="record" :dictList="dictList" />
  </div>
</template>
    
<script>
import { Attendance } from '@/api/attendance'
import PTable from '@/components/PTable';
import ItemMoudle from './modules/ItemMoudle.vue';
import dayjs from 'dayjs'
export default {
  components: {
    PTable,
    ItemMoudle
  },
  data() {
    return {
      // 导出
      json_fields: {
        '姓名': 'data32',
        '部门名称': 'data33',
        '次数（次）': 'qjCount',
        '时长（天）': 'duration',
      },
      json_data: [],
      form: {
        deptId: '',
        userId: '',
        date: [new Date(), new Date()]
      },
      columns: [
        {
          label: '基本信息',
          children: [
            {
              label: '序号',
              scopedSlots: 'sn',
              width: 80,
              fixed: "left"
            },
            {
              label: '姓名',
              prop: 'data32'
            },
            {
              label: '部门',
              prop: 'data33'
            }
          ]
        },
        {
          label: '请假明细',
          children: [{
            label: '次数(次)',
            prop: 'qjCount',
            // width: 100
          },
          {
            label: '时长(天)',
            prop: 'duration',
            // width: 100
          },
          {
            label: '详细',
            scopedSlots: 'action',
            // width: 100
          }
          ]
        }
      ],
      list: [
        {
          title: '请假总人数',
          count: 0
        },
        {
          title: '事假',
          count: 0
        },
        {
          title: '婚假',
          count: 0
        },
        {
          title: '丧假',
          count: 0
        },
        {
          title: '产假',
          count: 0
        }
      ],
      loadData: (pageParam) => {
        const startDate = dayjs(this.form.date[0]).format('YYYY-MM-DD')
        const endDate = dayjs(this.form.date[1]).format('YYYY-MM-DD')
        const data = {
          startDate,
          endDate,
          pageParam,
          userId: this.getUserInfo.deptName === '办公室' ?  this.form.userId : this.getUserInfo.userId,
          deptId: this.form.deptId,
          exType: this.form.type
        }
        return Attendance.getLeaveList(this, data).then(res => {
          this.json_data = res.data.dataList
          return res
        })
      },
      visible: false,
      record: [],
      userList: [],
      deptList: [],
      dictList: [
        {
          id: '1',
          name: '事假'
        },
        {
          id: '2',
          name: '病假'
        },
        {
          id: '3',
          name: '年假'
        },
        {
          id: '4',
          name: '婚假'
        },
        {
          id: '5',
          name: '丧假'
        },
        {
          id: '6',
          name: '产假'
        },
        {
          id: '7',
          name: '陪产假'
        }
      ]
    }
  },
  created() {
    this.getList()
    this.initData()
  },
  methods: {
    getList() {
      Attendance.gitDict(this, { dictId: '1440944417170001920' }).then(res => {
        this.userList = res.data
      })
      Attendance.gitDict(this, { dictId: '1630757245237071872' }).then(res => {
        this.deptList = res.data
      })
    },
    initData() {
      const data = {
        startDate: dayjs(this.form.date[0]).format('YYYY-MM-DD'),
        endDate: dayjs(this.form.date[1]).format('YYYY-MM-DD'),
        userId: this.form.userId,
        deptId: this.form.deptId
      }
      Attendance.getLeaveNum(this, data).then(res => {
        this.list[0].count = res.data.count
        this.list[1].count = res.data.sjCount
        this.list[2].count = res.data.hjCount
        this.list[3].count = res.data.sangjCount
        this.list[4].count = res.data.cjCount
      })
    },
    submitForm(flag = true) {
      this.initData()
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    handleLook(record) {
      this.record = record.map((item, index) => {
        item.index = index + 1
        if (item.holidayType && !item.holidayName) item.holidayName = this.dictList.find(data => data.id === item.holidayType).name
        return item
      })
      this.visible = true
    }
  }
}
</script>
    
<style lang="scss" scoped>
.record {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 20px 0 40px;

  .record-box {
    min-width: 100px;
    text-align: center;
    border: 1px solid #dedede;

    .title {
      background-color: #f1efef;
      padding: 5px 20px;
    }

    .count {
      text-align: center;
      padding: 15px 0;
    }
  }
}
.action {
  display: flex;
}
</style>
    